<template>
  <div class="dc-overview">
    <div style="width: 100%; height: 500px;" v-if="!isLoadedData"></div>
    <!-- 头部导航栏 -->
    <div class="dc-overview__header">
      <div class="dc-overview__header-inner clearfix">
        <div class="title-box float-left">
          <el-dropdown
            style="margin-right: 10px;"
            trigger="click"
            class="title-box-drop"
            @command="onHeaderMenuDropdownCommand"
          >
            <span
              class="el-dropdown-link"
              style="display: inline-block; vertical-align: baseline; width: 24px; height: 24px;"
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                <path
                  d="M3 5h2c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1zm0 6h2c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1zm0 6h2c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1zM9 5h12c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1zm0 6h12c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1zm0 6h12c.6 0 1 .4 1 1s-.4 1-1 1H9c-.6 0-1-.4-1-1s.4-1 1-1z"
                  fill="#ffffff"
                />
              </svg>
            </span>
            <el-dropdown-menu slot="dropdown" class="dc-overview__header-dropdown">
              <el-dropdown-item
                v-for="item in paragrahTabs"
                :key="item.paragraph_id"
                :command="item.paragraph_id"
              >
                <div
                  class="header-dropdown-item"
                  @click="onParagraphTabClick(item)"
                >{{item.tab_name}}</div>
              </el-dropdown-item>
              <el-dropdown-item command="photo">
                <div class="header-dropdown-item">{{$t('views.overview.header.photos')}}</div>
              </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <h2>{{name}}</h2>
        </div>
        <div class="dc-overview__header-right float-right clearfix">
          <ul class="nav float-left sub-title-menu">
            <li class="nav-item" v-for="item in paragrahTabs" :key="item.id">
              <a
                href="javascript:;"
                class="nav-link"
                @click="onParagraphTabClick(item)"
              >{{item.tab_name}}</a>
            </li>
            <li class="nav-item" v-if="photoList && photoList.length">
              <a
                href="javascript:;"
                class="nav-link"
                @click="onModuleItemClick('photo')"
              >{{$t('views.overview.header.photos')}}</a>
            </li>
          </ul>
          <div class="header-download float-left" v-if="downloads && downloads.length">
            <a href="javascript:;" class="nav-link" @click="onModuleItemClick('download')">
              <i class="menu-icon-download"></i>
            </a>
          </div>
          <div class="invite-box float-left">
            <el-button
              type="primary"
              class="invite-btn"
              @click="onHeaderInviteBtnClick"
            >{{$t('views.overview.header.investBtn')}}</el-button>
          </div>
        </div>
      </div>
    </div>
    <!-- 顶部大图的部分内容 -->
    <div class="dc-overview__top">
      <div class="dc-overview__top-back">
        <img :src="topBackImageUrl" alt class="back-media" />
      </div>
      <div class="dc-overview__top-content">
        <div class="dc-overview__top-main">
          <div class="main-inner">
            <div class="main-content">
              <h3 class="top-main-title">{{name}}</h3>
              <p class="top-main-desc">{{desc}}</p>
              <div class="main-ctr-box" v-if="topPdfUrl || topVideoUrl">
                <el-button
                  class="main-ctr-button"
                  v-if="topVideoUrl"
                  @click="onTopVideoBtnClick"
                >{{$t('views.overview.top.videoBtn')}}</el-button>
                <el-button
                  class="main-ctr-button"
                  v-if="topPdfUrl"
                  @click="onTopPdfBtnClick"
                >{{$t('views.overview.top.demoBtn')}}</el-button>
              </div>
            </div>
          </div>
        </div>
        <div class="dc-overview__top-footer">
          <div class="footer-inner">
            <div class="footer-item" v-for="word in words" :key="word.title">
              <p>{{word.desc}}</p>
              <h4>{{word.title}}</h4>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 投资按钮，在小屏的情况下会出现 -->
    <div class="dc-overview__invest-box">
      <el-button
        type="primary"
        @click="onHeaderInviteBtnClick"
      >{{$t('views.overview.header.investBtn')}}</el-button>
    </div>
    <!-- 基本的信息-->
    <div class="dc-overview__module" ref="brights" v-if="brights && brights.length">
      <h3 class="dc-overview__title">{{brightsTitle}}</h3>
      <el-row :gutter="40">
        <el-col :lg="8" v-for="(item, index) in brights" :key="index">
          <div
            class="dc-overview__base-item"
            :style="{background: `url('${item.icon_url}') no-repeat top center`, backgroundSize: '85px 85px'}"
          >
            <h3>{{item.title}}</h3>
            <div class="item-content">
              <p>{{item.desc}}</p>
            </div>
          </div>
        </el-col>
      </el-row>
    </div>
    <dc-overview-paragrah
      :ref="paragraph.id"
      v-for="(paragraph, index) in paragraphs"
      :key="index"
      :data="paragraph"
    ></dc-overview-paragrah>
    <div class="dc-overview__module" ref="photo" v-if="photoList && photoList.length">
      <div class="dc-overview__detail">
        <dc-overview-title :title="$t('views.overview.pages.photos')"></dc-overview-title>
        <dc-overview-photo :photo-list="photoList"></dc-overview-photo>
      </div>
    </div>
    <div class="dc-overview__module" ref="download" v-if="downloads && downloads.length">
      <div class="dc-overview__detail">
        <dc-overview-title :title="$t('views.overview.pages.downloads')"></dc-overview-title>
        <dc-overview-download :download-list="downloads"></dc-overview-download>
      </div>
    </div>
    <!-- disclaimers -->
    <!-- <div class="dc-overview__dialog-link">
      <el-button type="text" @click="onDisclaimersClick">DISCLAIMERS & CONFIDENTIALITY</el-button>
    </div> -->
    <el-dialog
      :title="dialogTitle"
      :fullscreen="true"
      :visible.sync="dialogVisible"
      custom-class="dc-overview__dialog"
      width="30%"
    >
      <div class="dialog-content" :class="{'is-image': dialogType === 'image'}">
        <img v-if="dialogType === 'image'" :src="dialogData" alt />
        <div class="content-text" v-if="dialogType==='text'">{{dialogData}}</div>
      </div>
    </el-dialog>
    <!--  -->
    <el-dialog
      :title="$t('views.overview.videoDialogTitle')"
      top="20vh"
      width="600px"
      :append-to-body="true"
      :visible.sync="videoDialogVisible"
    >
      <dc-overview-video-dialog :url="topVideoUrl"></dc-overview-video-dialog>
    </el-dialog>
  </div>
</template>

<script>
import loading from "../../common/mixins/loading";
import services from "../../services";
import $ from "jquery";
import DcOverviewTitle from "./overviewTitle";
import DcOverviewPhoto from "./overviewPhoto";
import DcOverviewDownload from "./overviewDownload";
import DcOverviewParagrah from "./overviewParagrah";
import DcOverviewVideoDialog from "./overviewVideoDialog";
// import DcOverviewBarChart from './overview-bar-chart';
export default {
  name: "overview",
  mixins: [loading],
  components: {
    DcOverviewTitle,
    DcOverviewPhoto,
    DcOverviewDownload,
    DcOverviewParagrah,
    DcOverviewVideoDialog
    // DcOverviewBarChart
  },
  data() {
    return {
      isLoadedData: false,
      id: "",
      name: "",
      desc: "",
      topBackImageUrl: "",
      words: [],
      brightsTitle: "",
      brights: [],
      paragraphs: [],
      paragrahTabs: [],
      photoList: [],
      downloads: [],
      videoDialogVisible: false,
      topPdfUrl: "",
      topVideoUrl: "",
      dialogVisible: false,
      dialogTitle: '',
      dialogData: '',
      dialogType: 'text'
    };
  },
  created() {
    this.id = this.$route.params.id;
  },
  mounted() {
    this.showLoading();
    this._getOverviewData().finally(() => {
      this.closeLoading();
    });
  },
  computed: {
    topBoxStyle() {
      return {
        background: `url(${this.topBackImageUrl}) no-repeat top center`,
        backgroundSize: "cover"
      };
    }
  },
  methods: {
    _parseOverviewData(data) {
      this.name = data.name;
      this.topBackImageUrl = data.bgimg_url;
      this.desc = data.desc;
      if (Array.isArray(data.words)) {
        this.words = data.words;
      } else {
        this.words = [];
      }
      this.brightsTitle = data.brights_title;
      if (Array.isArray(data.brights)) {
        this.brights = data.brights;
      } else {
        this.brights = [];
      }
      this.paragrahTabs = data.paragrah_tabs;
      if (Array.isArray(data.paragraphs)) {
        this.paragraphs = data.paragraphs;
      } else {
        this.paragraphs = [];
      }
      if (Array.isArray(data.photos)) {
        this.photoList = data.photos;
      } else {
        this.photoList = [];
      }
      if (Array.isArray(data.downloads)) {
        this.downloads = data.downloads;
      } else {
        this.downloads = [];
      }
      this.topPdfUrl = data.intro_pdf_url;
      this.topVideoUrl = data.intro_view_url;
    },
    _getOverviewData() {
      return new Promise((resolve, reject) => {
        let _data = {
          case_id: this.id
        };
        services.getOverviewData(_data).then(response => {
          if (response && response.case) {
            this._parseOverviewData(response.case);
          } else {
            this.$message({
              message: "Get Overview Data error",
              type: "error"
            });
          }
          this.isLoadedData = true;
          resolve();
        }, reject);
      });
    },
    jumpToParagraph($el) {
      if ($el) {
        let top = $($el).offset().top;
        let headerHeight = $(".dc-module.is-header").height();
        let overHeaderHeight = $(".dc-overview__header").height();
        $("html,body").animate({
          scrollTop: top - headerHeight - overHeaderHeight
        });
      }
    },
    onHeaderInviteBtnClick() {
      this.$router.push({ path: `/investment/${this.id}` });
    },
    onHeaderMenuDropdownCommand(name) {
      let names = ["brights", "photo", "download"];
      if (names.includes(name)) {
        const $module = this.$refs[name];
        if ($module) {
          this.jumpToParagraph($module);
        }
      } else {
        const $module = this.$refs[name];
        if ($module && Array.isArray($module) && $module.length) {
          let $el = $module[0].$el;
          this.jumpToParagraph($el);
        }
      }
    },
    onParagraphTabClick(tabItem) {
      if (tabItem) {
        let name = tabItem.paragraph_id;
        const $module = this.$refs[name];
        if ($module && Array.isArray($module) && $module.length) {
          let $el = $module[0].$el;
          this.jumpToParagraph($el);
        }
      }
    },
    onModuleItemClick(name) {
      const $module = this.$refs[name];
      if ($module) {
        this.jumpToParagraph($module);
      }
    },
    onTopVideoBtnClick() {
      this.videoDialogVisible = true;
    },
    onTopPdfBtnClick() {
      window.open(this.topPdfUrl);
    },
    onDisclaimersClick() {
      this.dialogTitle = 'DISCLAIMERS & CONFIDENTIALITY'
      this.dialogVisible = true;
      this.dialogData = 'This presentation on this site (the “Website”) and in the Final Investment Memorandum has been prepared by Realprimior LLC, a broker/dealer registered with FINRA and a member SIPC (together with its affiliates and their respective employees, agents, directors and officers, collectively, “primior”) on the basis of information obtained from the Sponsor and other sources, some of which may be public, as of the specified date. Neither primior nor the Sponsor undertake any duty to update the information. Neither primior nor the Sponsor makes or gives any representation, warranty or guarantee, whether express or implied, that the information contained in this Website or otherwise supplied to the recipient, at any time by or on behalf of primior or the Sponsor whether in writing or not, relating to the opportunity discussed herein is complete or accurate or that it has been or will be audited or independently verified, or that reasonable care has been taken in compiling, preparing or furnishing the information. This Website is not intended to be exhaustive and, in particular, may not contain disclosure of all of the risks associated with the opportunity; potential investors must perform their own examination and inspection of the opportunity and information relating to same, and shall rely solely on such examination and investigation and not on this Website or any materials, statements or information contained herein or otherwise provided.\n\nAll of the statements in this Website represent the beliefs and opinions of primior and the Sponsor as of the date hereof, should not be relied upon as statements of fact and may constitute forward-looking statements that are not historical facts. These forward-looking statements include statements, express or implied, regarding the current expectations, opinions and beliefs of primior or the Sponsor, as well as the assumptions on which those statements are based. Words such as “believes,” “estimates,” “expects,” “endeavors,” “anticipates,” “intends,” “plans,” “targets,” “should” and “objective” and variations of such words and similar words also identify forward-looking statements. Such statements are forward-looking in nature and involve a number of known and unknown risks, uncertainties and other factors, including those described in this memorandum. Any forward-looking statement, including any estimated return, contained in this Website is not a guaranty, assurance or representation by primior or the Sponsor as to future matters and nothing contained herein should be relied upon as a guaranty, assurance or representation as to future matters.\n\nThe target return information presented herein represents underwriting criteria used by primior to analyze the investment opportunity and is provided as for illustrative purposes on how the Property is being underwritten and priced and once it is owned how it will be managed and does not represent a projection of performance returns to investors. Target return information is based upon certain assumptions, those outlined in this Memorandum or embedded in the financials in this Memorandum and in any Final Investment Memorandum with respect to the offering. Underwriting for target net returns includes deduction of fees and anticipated expenses but not taxes. An investment has a high degree of risk, and there can be no assurances that all or any of the assumptions will be true or that actual performance will bear any relation to these estimates. The estimates and other pro forma data set forth in this Website were not prepared with a view toward compliance with U.S. Generally Accepted Accounting Principles or any other published standards. Estimates and other pro forma data are derived from estimates, as of the date of this Website, based on certain assumptions, which are inherently subject to significant business, economic and competitive uncertainties and contingencies. Data relating to Property cash flows, financing, and other Property performance measures are based on assumptions and estimates, some of which are described here. Independent estimates about the future benefits of the opportunity and pro forma data should be developed by investors before any decision is made on whether or not to invest and investors should not rely on the estimates and pro forma data contained herein. Summaries of any documents about the opportunity discussed herein are not intended to be comprehensive or all inclusive, but rather only outline some of the provisions contained therein and are qualified in their entirety by the actual document to which they relate.\n\nThe calculations of “tax equivalent”, “after tax” or similar tax-adjusted returns use a number of important assumptions, many or none of which may apply to any specific investor. A federal capital gains tax rate of 23.8% is used and is assumed to be in effect for the entire time frame indicated. The federal capital gains tax rate includes the highest federal capital gains rate of 20% and the 3.8% net investment income tax that applies to taxpayers in certain circumstances. We assume no state income tax is applied to the Investment or any comparison “standard” investment. The expected annual return selected is used to calculate a compounded return on an annual basis for the holding period indicated and is the same rate for all scenarios being compared. The assumption for a standard investment is that tax is paid at the time the gain is realized using the above mentioned 23.8% capital gains tax rate. The after-tax remainder is assumed to be invested and held for the time period of the Investment, and then sold, with tax being paid on additional gains realized at a rate of 23.8%. The gain calculation on the Investment is done under the assumption that only realized gain is applied to invest in the Investment, that tax is initially deferred and after seven years the Investment has received a 15% step-up in basis. As of the seventh anniversary of the Investment, the deferred tax is due and 85% of the deferred gain is taxed at 23.8%. After the investment has been held for ten years, the Investment is sold, and we assume no tax is due on the additional appreciation that has compounded over the ten-year period. Investors will not actually earn the tax-equivalent IRR. Please see the O-Zone Benefit - Tax-Equivalent IRR page in the investment memorandum for additional information and details.\n\nHistorical information is provided for informational purposes only. Past performance on other projects is not indicative of any result with respect to the Property. This Website is not to be construed as investment, tax or legal advice in relation to the relevant subject matter; potential investors must seek their own legal or other professional advice.\n\nThis Website is a summary of information and you should refer to the Final Investment Memorandum for additional details and disclaimers. This presentation and the information contained herein (including the terms of the investment) are subject to completion or amendment without notice. Under no circumstances shall this Website constitute an offer or invitation to make an investment, in any form. It has been prepared for the sole purpose of obtaining indications of interest about a potential investment, which will only be made upon the basis of the negotiations and executions of full investment documentation. This is not an offer of an investment opportunity in any jurisdiction where it is prohibited or where a pre-filing or other action is required. The information in this Website is confidential and is furnished solely for the purpose of review in connection with the opportunity discussed herein. If an offering is made it shall be pursuant to a final offering memorandum which could contain material information not contained herein (including risks related to an investment) and which shall supersede this information in its entirety. Such final offering memorandum will be furnished to qualified investors on a confidential basis at their request for their consideration of an offering. Any decision to invest should be made after reviewing such final offering memorandum and conducting such investigation as the investor deems necessary (including consulting the investor‘s own legal, accounting and tax advisors). The information is not to be used or reproduced for any other purpose or distributed or made available to any other person without the express written consent of primior. The opportunity is subject to prior placement and withdrawal, change, cancellation or modification, all without notice.';
      this.dialogType = "text";
    }
  }
};
</script>